import {
  emailNotValidMessage,
  fileTooBigMessage,
  incorrectFileTypeMessage,
  mustFillMessage,
  nimNotValidMessage,
  numericDigitOnlyMessage,
  tooLongMessage,
} from '../../utils/constant';

export const reqData = [
  {
    attr: 'Nama',
    rules: {
      required: { value: true, message: mustFillMessage },
      maxLength: { value: 50, message: tooLongMessage },
    },
    type: 'text',
    req: true,
  },
  {
    attr: 'NIM',
    req: true,
    type: 'number',
    rules: {
      required: { value: true, message: mustFillMessage },
      maxLength: { value: 8, message: nimNotValidMessage },
      minLength: { value: 8, message: nimNotValidMessage },
      pattern: { value: /^[0-9]*$/, message: nimNotValidMessage },
    },
  },
  {
    attr: 'Nomor Telepon',
    req: true,
    type: 'tel',
    rules: {
      required: { value: true, message: mustFillMessage },
      maxLength: { value: 13, message: tooLongMessage },
      pattern: { value: /^[0-9]*$/, message: numericDigitOnlyMessage },
    },
  },
  {
    attr: 'Email',
    type: 'email',
    req: true,
    rules: {
      required: { value: true, message: mustFillMessage },
      maxLength: { value: 50, message: tooLongMessage },
      pattern: { value: /^\S+@\S+.\S+$/i, message: emailNotValidMessage },
    },
  },
];

export const TTLData = [
  {
    attr: 'Tempat lahir',
    req: true,
    type: 'text',
    rules: {
      required: { value: true, message: mustFillMessage },
      maxLength: { value: 50, message: tooLongMessage },
    },
  },
  {
    attr: 'Tanggal lahir',
    req: true,
    type: 'date',
    shrink: true,
    rules: {
      required: { value: true, message: mustFillMessage },
    },
  },
];

export const SKRData = [
  {
    attr: 'Nama Ortu',
    req: false,
    rules: {
      maxLength: { value: 50, message: tooLongMessage },
    },
    type: 'text',
  },
  {
    attr: 'NIP Ortu',
    req: false,
    rules: {
      maxLength: { value: 18, message: 'NIP not valid' },
      minLength: { value: 18, message: 'NIP not valid' },
      pattern: { value: /^[0-9]*$/, message: numericDigitOnlyMessage },
    },
    type: 'text',
  },
  {
    attr: 'Instansi Ortu',
    req: false,
    rules: {
      maxLength: { value: 50, message: tooLongMessage },
    },
    type: 'text',
  },
  {
    attr: 'Pangkat/Gol Ortu',
    req: false,
    rules: {
      maxLength: { value: 50, message: tooLongMessage },
    },
    type: 'text',
  },
];

export const majorsData = [
  {
    attr: 'Jurusan',
    req: true,
    options: [
      { value: 'IF', label: 'Teknik Informatika' },
      { value: 'II', label: 'Sistem dan Teknologi Informasi' },
      { value: 'EL', label: 'Teknik Elektro' },
      { value: 'EP', label: 'Teknik Tenaga Listrik' },
      { value: 'ET', label: 'Teknik Telekomunikasi' },
      { value: 'EB', label: 'Teknik Biomedis' },
      { value: 'ME', label: 'Magister Teknik Elektro' },
      { value: 'MF', label: 'Magister Teknik Informatika' },
      { value: 'EI', label: 'Doktor Teknik Elektro dan Informatika' },
    ],
    rules: {
      required: { value: true, message: mustFillMessage },
    },
  },
];

export const serviceData = [
  {
    attr: 'Permintaan Pelayanan',
    req: true,
    options: [
      { value: 1, label: 'Legalisir Transkrip, Ijazah, dan Terjemahan Ijazah' },
      { value: 2, label: 'Penyediaan Surat Keterangan' },
      { value: 3, label: 'Surat Permohonan Kerja Praktek' },
      { value: 4, label: 'Pembuatan Transkrip Hilang Bagi Alumni' },
    ],
    rules: {
      required: { value: true, message: mustFillMessage },
    },
  },
];

export const uploadData = [
  {
    attr: 'Upload Image',
    label: 'Foto/Scan KTM/KTP/Kartu Identitas',
    acceptedType: '.jpg,.jpeg,.png',
    placeholder: '1 Foto/Scan KTM/KTP/Kartu Identitas dalam jpg/jpeg/png',
    rules: {
      required: { value: true, message: mustFillMessage },
      validateSize: { value: 7000000, message: fileTooBigMessage },
      validateType: { value: null, message: incorrectFileTypeMessage },
    },
    req: true,
  },
  {
    attr: 'Upload Required File (PDF)',
    label: 'Scan Dokumen',
    acceptedType: '.pdf',
    placeholder: '1 Hasil Scan Dokumen dalam pdf',
    rules: {
      required: { value: true, message: mustFillMessage },
      validateSize: { value: 7000000, message: fileTooBigMessage },
      validateType: { value: null, message: incorrectFileTypeMessage },
    },
    req: true,
  },
];
